import React, { useState, useEffect, useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './Login.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { handleRedirectInternal, mapData } from '../../../Product/common/components'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'

import AuthContext from '../../../Product/context/auth/authContext'
import { Copyrightinfo, Logo } from '../../../utils'
import Layout from '../Layout'
import LoginFunction from '../../../utils/CommonFunctionality/LoginFunction'
import SEO from '../../../utils/CommonFunctionality/SEO'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const LoginComponent = () => {
    const isWizardTheme = document.body.classList[1] == 'wizardTheme'
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    return (
        <>
            {isPrimeBids ? (
                <SEOTAG page="Login" />
            ) : (
                <SEO title={`${global?.storeDetails?.name} | Login`} />
            )}
            <Layout>
                <div className="clearfix row vcaLogin">
                    <div className="col-12">
                        <div className="loginFormBox">
                            <LoginFunction
                                title={!isWizardTheme ? 'Login' : 'Log In'}
                                subTitle="Continue logging to your account"
                            />
                        </div>
                    </div>
                </div>
            </Layout>{' '}
        </>
    )
}

export default LoginComponent
